import axios from 'axios';
import { Preferences } from '@capacitor/preferences';
import { Device } from '@capacitor/device';
import WiseStore from '@/store';
import { syncLoginToWeb, syncLogoutFromWeb, resetSystemBrowserSync } from '@/helpers/inAppBrowserLogin';
//import settings from '@/WiseSettings.js';
let accessTokenValidTimestamp = null
let lastHost = null
// Used for to populate user state on initial load and reset user state on logout
const getUserDefaultState = () => {
	return {
		loggedIn: false,
		user: null,
		accessTokenValidTimestamp: null,
		deviceValidTimestamp: null,
		overrideHostUser: null,
		parentUser: null,
		subProfileActive: false
	}
}

export default {
	namespaced: true,
	state: getUserDefaultState(),
	getters: {
		loggedIn: (state) => state.loggedIn,
		user: (state) => state.user,
		parentUser: (state) => state.parentUser,
		subProfileActive: (state) => state.subProfileActive,
		activeUser: (state) => {
			if (state.overrideHostUser !== null) {
				return {
					...state.user,
					...state.overrideHostUser,
				}
			}

			return state.user;
		},
	},
	mutations: {
		mutateUserStateToDefault(state) {
			Object.assign(state, getUserDefaultState())
		},
		mutateLoggedInUserData(state, user) {
			//console.log(`%cUser data set to:`, 'color: yellow; padding: 5px 0', user)
			state.user = user;
		},
		mutateLoggedIn(state, loggedIn) {
			if (loggedIn === false) {
				console.log(`%cLogged in set to:`, 'color: yellow; padding: 5px 0', false)
			}
			state.loggedIn = loggedIn;
		},
		mutateAccessTokenValidTimestamp(state, accessTokenValidTimestamp) {
			state.accessTokenValidTimestamp = accessTokenValidTimestamp;
		},
		mutateDeviceValidTimestamp(state, deviceValidTimestamp) {
			state.deviceValidTimestamp = deviceValidTimestamp
		},
		mutateOverrideHostUser(state, user) {
			state.overrideHostUser = user;
		},
		setSubProfileActive(state, subProfile) {
		if (!state.subProfileActive && !state.parentUser) {
			state.parentUser = { ...state.user }
		}
			state.user = {
				...state.user,

				personId: subProfile.subPersonId,
				firstName: subProfile.linkedPersonFirstName,
				familyName: subProfile.linkedPersonLastName,
				fullName: subProfile.linkedPersonName,
				dateOfBirth: subProfile.linkedPersonDateOfBirth,
				email: subProfile.linkedPersonEmail,
				phone: subProfile.linkedPersonPhone,
				streetAddress: subProfile.linkedPersonStreetAddress,
				country: subProfile.linkedPersonCountry,
				postalCode: subProfile.linkedPersonPostalCode,
				gender: subProfile.linkedPersonGender,
				profileImgUrl: subProfile.profileImgUrl,
				userId: subProfile.subUserId,
				subProfileActive: true,
				parentPersonId: state.parentUser?.personId,
			}
			console.log("subProfile, ", subProfile)
			console.log("User: ", state.user)
			state.subProfileActive = true

			Preferences.set({
				key: "activeSubProfile",
				value: JSON.stringify(subProfile)
			})
			Preferences.set({ key: "parentUser", value: JSON.stringify(state.parentUser) })
		},
		restoreSubProfileSession(state, { parentUser, subProfile }) {
			state.parentUser = parentUser

			state.user = {
				...parentUser,
				personId: subProfile.subPersonId,
				userId: subProfile.subUserId,
				firstName: subProfile.linkedPersonFirstName,
				familyName: subProfile.linkedPersonLastName,
				dateOfBirth: subProfile.linkedPersonDateOfBirth,
				email: subProfile.linkedPersonEmail,
				phone: subProfile.linkedPersonPhone,
				streetAddress: subProfile.linkedPersonStreetAddress,
				country: subProfile.linkedPersonCountry,
				postalCode: subProfile.linkedPersonPostalCode,
				fullName: subProfile.linkedPersonName,
				gender: subProfile.linkedPersonGender,
				profileImgUrl: subProfile.profileImgUrl,
				subProfileActive: true,
				parentPersonId: parentUser?.personId,
			}

			state.subProfileActive = true
		},
		setUserImage(state, url) {
			if (state.user) {
				state.user.profileImgUrl = url;
				Preferences.set({
					key: `profileImageUrl`,
					value: url
				}).catch(err => console.error("Virhe tallennettaessa profiilikuvaa Preferencesiin", err));
			}
		},

		clearSubProfileActive(state) {
			if (state.parentUser) {
				state.user = { ...state.parentUser }
			}
			state.parentUser = null
			state.subProfileActive = false
			console.log(state.subProfileActive)
			Preferences.remove({ key: "activeSubProfile" })
			Preferences.remove({ key: "parentUser" })
			console.log("user clearing jälkeen: ", state.user)
		}
	},
	actions: {
		resetAccessTokenValidTimestamp({ commit }) {
		commit('mutateAccessTokenValidTimestamp', null)
		},
		async validateAccessTokenFromStorage({ dispatch, getters, rootGetters, rootState, commit }, settings = {}) {
			const activeHost = rootGetters["common/activeHost"];
			const { value: accessToken } = await Preferences.get({ key: `access_token-${rootState.common.settings.appId}` })
			const { value: selectedHost } = await Preferences.get({ key: `selectedHost-${rootState.common.settings.appId}` })

			let legitToken = false;
			let user = null;
			
			if (!accessToken || !selectedHost) {
				// console.warn('No access token or selected host found in storage');
				return Promise.reject('No access token found from local storage');
			}
			
			if (activeHost.sessionType) {
				axios.defaults.headers.common['x-session-type'] = activeHost.sessionType;
			}

			// Validate access token if last validation over 5min ago
			if (Date.now() - accessTokenValidTimestamp < 300000  && lastHost === activeHost.name) {
				return true;
			}

			accessTokenValidTimestamp = Date.now()

			try {
				const getUrl = (host) => {
					let locale = rootGetters['common/userLocale']
					// if the language is changed in the app, it appears in the function settings object
					if (settings && settings.locale) {
						locale = settings.locale
					}

					const { 
						restUrl,
						sessionType
					} = host
					if (sessionType) {
						axios.defaults.headers.common['x-session-type'] = sessionType;
					}
	
					let url = `${ restUrl }auth/session/?lang=${ locale }`
	
					return url
				}
				let url = getUrl(activeHost)
				// if user already exists, only ping the original session
				if (getters['user'] && lastHost === activeHost.name) {
					url = getUrl(rootGetters['common/originalHost'])
					url += `${ url.includes('?') ? '&' : '?' }ping=1`
				}

				const { data } = await axios.get(
					url,
					{
						headers: { 'Authorization': `token ${ accessToken }` }
					}
				)
				
				if (data?.user?.isGolfpisteSession 
					&& location.href.includes('app.wisegolf.fi')) {
					return false
				}

				legitToken = data.success;
				if (data.user) {
					user = data.user;
				}			
				
				lastHost = activeHost.name
			} catch (error) {
				console.log(error)
			}

			if (legitToken) {
				axios.defaults.headers.common['Authorization'] = `token ${ accessToken }`;
				commit('mutateLoggedIn', true)

				if (user) {
					commit('mutateLoggedInUserData', user) // Populate user object with logged in user data
				}

				const { value: activeSubProfile } = await Preferences.get({ key: "activeSubProfile" })
				const { value: parentUser } = await Preferences.get({ key: "parentUser"})
				if (activeSubProfile && parentUser) {
					commit("restoreSubProfileSession", {
						parentUser: JSON.parse(parentUser),
						subProfile: JSON.parse(activeSubProfile)
					})
				}
				if (user.profileImgUrl) {
					await Preferences.set({
						key: `profileImageUrl-${rootState.common.settings.appId}`,
						value: user.profileImgUrl
					});
				}

				if (rootState.common.settings.useGymFeatures) {
					// Update Door/Location data from server
					await dispatch('door/getDoorAndLocationDataFromServer', {}, {root: true})
					await dispatch('door/getUserAccessRights', {}, {root: true})
				}
			} else {
				commit('mutateLoggedIn', false)
				commit('mutateLoggedInUserData', null)
			}

			return legitToken;
		},

		async validateUserDevice({ rootGetters, rootState, state, commit }, updateInfo = false) {
			if ((Math.floor(Date.now() / 1000) - state.deviceValidTimestamp) < 180) {
				return true;
			}
			const activeHost = rootGetters["common/activeHost"];
			const deviceUUID = await Device.getId();
			const args = {
				uuid: deviceUUID.identifier,
				appId: rootState.common.settings.appId,
				update: updateInfo
			}
			try {
				const data = await axios.post(`${activeHost.restUrl}validatedevice/`, args)
				console.log("validateUserDevice success: ", data)

				if (data.data.success) {
					commit('mutateDeviceValidTimestamp',  Math.floor(Date.now() / 1000))
					commit('mutateLoggedIn', true)
					return true
				} else if (!data.data.success) {
					return false
				}
			} catch (error) {
				console.error("validateUserDeviceError: ",error)
				return Promise.reject(error)
			}
		},

		// Update user notification settings to DB
		async updateUserSettings( {state, rootState, rootGetters}, newSettings) {
			try {
				const deviceGetInfo = await Device.getInfo();
				const deviceGetId = await Device.getId();
				// Map deviceInfo values for backend
				const deviceInfo = {
					uuid: deviceGetId.identifier,
					manufacturer: deviceGetInfo.manufacturer,
					model: deviceGetInfo.model,
					platform: deviceGetInfo.operatingSystem,
					version: deviceGetInfo.osVersion
				}

				const settingsData = {
					appId: rootState.common.settings.appId,
					settings: {notifications: newSettings},
					user: state.user,
					device: deviceInfo,
					appVersion: rootState.common.settings.appVersion,
					binaryVersion: null
				}

				//console.log("Capacitor device plugins sending to server: ", settingsData)

				await axios.post(`${rootGetters["common/activeHost"].ajaxUrl}?updateusersettings=1&appauth=${rootGetters["common/activeHost"].appauth}`, settingsData)
			} catch (error) {
				console.error("Error on updateUserSettings():", error)
			}
		},

		async logIn({ rootGetters, commit, rootState }, loginFormData) {
			try {
				const activeHost = rootGetters['common/activeHost'];
				const { settings } = rootState.common;
				const headers = {};
				
				let loginUrl = `${ activeHost.ajaxUrl }?action=ajaxauthorize&appauth=${activeHost.appauth}`;
				if (activeHost.restUrl && activeHost.useRestLogin) {
					loginUrl = `${ activeHost.restUrl }/auth`;
				}
				
				if (activeHost.sessionType) {
					axios.defaults.headers.common['x-session-type'] = activeHost.sessionType;
				}
				
				const { data } = await axios.post(
					loginUrl, 
					loginFormData,
					{ headers }
				);
				axios.defaults.headers.common['Authorization'] = `token ${ data.access_token }`;

				await WiseStore.dispatch("common/getMobileAppSettings");
				applyPostLoginUI(activeHost);


				commit('mutateLoggedInUserData', data)
				
				commit('mutateAccessTokenValidTimestamp', Math.floor(Date.now() / 1000))

				if (data.profileImgUrl) {
					await Preferences.set({key: `profileImageUrl-${settings.appId}`, value: data.profileImgUrl});
				}

				await Preferences.set({ key: `access_token-${ settings.appId }`, value: data.access_token });
				await Preferences.set({ key: `selectedHost-${ settings.appId }`, value: activeHost.name });

				await syncLoginToWeb(activeHost.ajaxUrl, data.access_token, rootState.common.userLocale);
				if (loginFormData.saveCredentials === true) {

					await Preferences.set({ key: `username-${ settings.appId }`, value: loginFormData.username });
					await Preferences.set({ key: `password-${ settings.appId }`, value: loginFormData.password });

				} else if (loginFormData.saveCredentials === false){
					await Preferences.remove({ key: `username-${ settings.appId }` });
					await Preferences.remove({ key: `password-${ settings.appId }` });

				} else {
					console.error("Did not save to preferences")
				}
				return data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error(error)
					return Promise.reject(error)
				}
			}
		},

		async completeHakaLogin({ dispatch, commit, rootGetters, rootState }, { sessionId, hostName }) {
			const { settings } = rootState.common;
			const appId = settings.appId;

			await Preferences.set({ key: `access_token-${appId}`, value: sessionId });
			await Preferences.set({ key: `selectedHost-${appId}`, value: hostName });

			commit('common/setSelectedHost', hostName, { root: true });
			await dispatch('common/getMobileAppSettings', {}, { root: true });

			const valid = await validateAccessToken(rootGetters, sessionId);
			if (!valid) {
				return { success: false};
			}

			const activeHost = rootGetters['common/activeHost'];
			applyPostLoginUI(activeHost);

			const deviceValid = await dispatch('validateUserDevice');
			if (!deviceValid) {
				return { success: true, needDeviceValidation: true };
			}

			return { success: true };
		},

		// Clear session when changing host
		async clearSession(_, host ) {
			try {
				const headers = {};
				if (host.sessionType) {
					headers['x-session-type'] = host.sessionType;
				}
				const url = `${ host.restUrl }logout`
				await axios.post(url, {}, { headers })

				await syncLogoutFromWeb(host.ajaxUrl);
				await resetSystemBrowserSync();

			} catch (error) {
				if (error.response) {
					console.error("clearSession error ",error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error("clearSession error2 ",error)
					return Promise.reject(error)
				}
			}
		},

		async logOut({rootGetters, rootState, commit, dispatch }) {
			const activeHost = rootGetters["common/activeHost"];

			try {
				const url = `${ activeHost.restUrl }logout`
				await axios.post(url),
				await syncLogoutFromWeb(activeHost.ajaxUrl);
				await resetSystemBrowserSync();
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error(error)
					return Promise.reject(error)
				}
			}
			const { settings } = rootState.common;

			// Reset User vuex module states
			commit('mutateUserStateToDefault')
			console.log(`%cVuex user module states reset`, 'color: yellow; padding: 5px 0')

			// Reset Gym common vuex module states
			commit("gym_common/mutateGymCommonStateToDefault", {}, {root: true})
			console.log(`%cVuex gym common module states reset`, 'color: yellow; padding: 5px 0')

			// Reset Door vuex module states
			commit("door/mutateDoorStateToDefault", {}, {root: true})
			console.log(`%cVuex door module states reset`, 'color: yellow; padding: 5px 0')

			// Reset common vuex module states
			commit("common/mutateCommonStateToDefault", {}, {root: true})
			console.log(`%cVuex common module states reset`, 'color: yellow; padding: 5px 0')
			
			// Get MobileAppSettings back from DB after common state reset
			dispatch("common/getMobileAppSettings", {}, {root: true});

			try {
				delete axios.defaults.headers.common.Authorization

				const userPreferences = await Preferences.keys()
				const skipReset = ['screenMode', 'selectedHost', 'selectedLocale', 'username', 'password', 'pushNotificationsToast', 'checked-system-notifications', 'notifications-settings','saveCredentials', 'lastNotificationDate', 'unreadNotificationIds', 'savedCalendarIds' ]
				.map(key => `${ key }-${ settings.appId }`)
				
				userPreferences.keys.forEach(async (key) => {
					if (skipReset.includes(key) || key.includes('wise-subscribed-topics') || key.includes(`notifications-onboarding`)) return;
					await Preferences.remove({ key })
				})

				if (settings.hosts.length > 1 && !settings.isBranded ) {
					Array.from(document.body.classList)
					.forEach(row => {
						if (row.includes(activeHost.className)) {
							document.body.classList.remove(row)
						}
					})
				}
				
				console.log(`%cLocal storage cleared!`, 'color: yellow; padding: 5px 0')
				console.log(`%cLogout success!`, 'color: lime; padding: 5px 0')
			} catch (error) {
				console.error("Error clearing local storage: ", error)
			}
		},

		async deleteLinkedPerson({ rootGetters }, { personId }) {
			const activeHost = rootGetters["common/activeHost"];
			const url = `${ activeHost.ajaxUrl }?appdeleteperson=1&appauth=${ activeHost.appauth }`;
			return await axios.post(url, {
				params: {
					personlinkreq: 1,
					personId: personId
				}
			})
		},

		async deleteUser({ rootGetters, rootState }) {
			try {
				const activeHost = rootGetters["common/activeHost"];
				const url = `${ activeHost.ajaxUrl }?appdeleteperson=1&appauth=${ activeHost.appauth }`;
				const personId = rootState.user.user.personId
				let data
				if (rootState.user.subProfileActive === true) {
					data = await axios.post(url, {
						params: {
							personlinkreq: 1,
							personId: personId
						}
					})
				} else {
					data = await axios.post(url)
				}
				return data
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error(error)
					return Promise.reject(error)
				}
			}
		},

		// special wisegolf endpoint for consenting user to another service provider
		async consentUser({ commit }, host) {
			
			try {
				let loginUrl = `${ host.restUrl }/app/signon/consent${ host.checkConsent ? '/?checkConsent=1' : '' }`;
				
				const { data } = await axios.post(loginUrl);

				if (data.user) {
					commit('mutateLoggedInUserData', data.user)
				}
				
				return data;
			} catch (error) {
				if (error.response) {
					console.error('wisegolf consent error: ', error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error('wisegolf consent error: ', error)
					return Promise.reject(error)
				}
			}
		},

		// Attempt to switch to a different host/gym with current user credentials
		// Returns success if login succeeds, or rejects if it fails
		async switchHostWithCredentials({ commit, rootState }, { targetHost, credentials }) {
			try {
				// Remove current auth to avoid conflicts
				// delete axios.defaults.headers.common['Authorization'];
				
				// Set new host's session type if needed
				// if (targetHost.sessionType) {
				// 	axios.defaults.headers.common['x-session-type'] = targetHost.sessionType;
				// }
				
				// Prepare login data
				const loginFormData = {
					username: credentials.username,
					password: credentials.password,
					saveCredentials: false
				};
				
				// Build login URL for target host
				let loginUrl = `${ targetHost.ajaxUrl }?action=ajaxauthorize&appauth=${targetHost.appauth}`;
				if (targetHost.restUrl && targetHost.useRestLogin) {
					loginUrl = `${ targetHost.restUrl }/auth`;
				}
				
				// Attempt login to target host
				const { data } = await axios.post(loginUrl, loginFormData);
				
				// Login successful - update auth header
				// axios.defaults.headers.common['Authorization'] = `token ${ data.access_token }`;
				
				// Update store with new user data
				commit('mutateLoggedInUserData', data);
				commit('mutateAccessTokenValidTimestamp', Math.floor(Date.now() / 1000));
				
				// Update preferences
				const appId = rootState.common.settings.appId;
				if (data.profileImgUrl) {
					await Preferences.set({
						key: `profileImageUrl-${appId}`,
						value: data.profileImgUrl
					});
				} else {
					await Preferences.remove({
						key: `profileImageUrl-${appId}`
					});
				}
				
				await Preferences.set({
					key: `access_token-${appId}`,
					value: data.access_token
				});
				
				await Preferences.set({
					key: `selectedHost-${appId}`,
					value: targetHost.name
				});
				
				// Sync login to web
				// await syncLoginToWeb(targetHost.ajaxUrl, data.access_token, rootGetters['common/userLocale']);

				commit('common/mutateSelectedHost', targetHost.name, { root: true });
				applyHostTheme(targetHost);
				return { success: true, data };
			} catch (error) {
				console.error('Failed to switch host with credentials:', error);
				return {
					success: false,
					error: error.response?.data || error
				};
			}
		}
	}
}
function applyHostTheme(newHost) {
  document.body.classList.add("wisegym");
	Array.from(document.body.classList).forEach(c => {
		if (c.startsWith("wisegym-")) document.body.classList.remove(c);
	});
	if (newHost?.className) {
		document.body.classList.add("wisegym");
		document.body.classList.add(newHost.className.toLowerCase())
	}
}
const applyPostLoginUI = (activeHost) => {
	if (activeHost?.className) {
		document.body.classList.add(activeHost.className.toLowerCase());
	}
};

const validateAccessToken = async (rootGetters, accessToken) => {
	try {
		const locale = rootGetters['common/userLocale']
		return await axios.get(`${rootGetters["common/activeHost"].ajaxUrl}?getsessiondata=1&appauth=${rootGetters["common/activeHost"].appauth}&lang=${ locale }`,
			{
				headers: { 'Authorization': `token ${accessToken}` }
			});
	} catch (error) {
		console.error(error)
	}
}
